export default "__VITE_ASSET__06a81412__"